import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule, AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core.module';
import { LocalesModule } from './locales-module';
import { FooterComponent } from './main/footer/footer.component';
import { HeaderComponent } from './main/header/header.component';
import { MainMenuComponent } from './main/main-menu/main-menu.component';
import { LocaleChangeComponent } from './main/header/locale-change/locale-change.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbComponent } from './main/header/breadcrumb.component';
import * as moment from 'moment';
import { PersonModule } from './person/person.module';
import { UserCountModule } from './user-count/user-count.module';
import { OrganizationModule } from './organization/organization.module';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { ExportsComponent } from './main/exports/exports.component';
import { AdministrationModule } from './administration/administration.module';
import { NotificationsComponent } from './notifications/notifications.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { FilterBarComponent } from './main/dashboard/filter-bar/filter-bar.component';
import { VerifyContactMailComponent } from './main/others/verify-contact-mail/verify-contact-mail.component';
import { DataPortalModule } from './data-portal/data-portal.module';
import { AuthService } from './auth/auth.service';
import { AddXsrfTokenHttpRequestInterceptor } from './shared/interceptors/add-xsrf-token-http-request-interceptor';
import { authConfig } from './auth/auth.config';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

export function initLocale() {
  return moment.locale(navigator.language);
}

export function initAuth(authService: AuthService) {
  return () => authService.initAuth();
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    MainMenuComponent,
    LocaleChangeComponent,
    BreadcrumbComponent,
    DashboardComponent,
    ExportsComponent,
    NotificationsComponent,
    UserRolesComponent,
    FilterBarComponent,
    VerifyContactMailComponent,
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    LocalesModule,
    SharedModule,
    HttpClientModule,
    PersonModule,
    UserCountModule,
    OrganizationModule,
    AdministrationModule,
    DataPortalModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.idmAuthURL],
        sendAccessToken: true
      }
    }),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: initLocale
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddXsrfTokenHttpRequestInterceptor,
      multi: true
    },
    {
      provide: AuthConfig,
      useValue: authConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
